import React, { useState, useEffect } from 'react';
import { BrokerAgreementSelect } from './BrokerAgreementSelect';
import { EntitySelector } from '../../../borrowers/common/BorrowerComponents';

export const BClientOrEntitySelectorType = {
    BClient: 0,
    Entity: 1,
};

export const BClientOrEntitySelector = ({
    brokerAgreementId = 0,
    borrowerEntityId = 0,
    onSelect,
    disabled = false,
    canEdit = true,
    required = true,
}) => {
    const [selectionType, set_selectionType] = useState(BClientOrEntitySelectorType.Entity);

    const styles = {
        formRow: { marginBottom: '0' },
        formColumn: { paddingBottom: '5px', paddingRight: '5px' },
    };

    const setSelectionType = (value) => {
        set_selectionType(value);
        onSelect && onSelect(value, null);
    };

    useEffect(() => {
        if (brokerAgreementId || borrowerEntityId) {
            if (brokerAgreementId) {
                set_selectionType(BClientOrEntitySelectorType.BClient);
            } else {
                set_selectionType(BClientOrEntitySelectorType.Entity);
            }
        }
    }, [brokerAgreementId, borrowerEntityId]);

    return (
        <>
            <div
                className='row'
                style={styles.formRow}
            >
                <div className='columns small-12 large-12'>
                    <input
                        type='radio'
                        name='isBorrowerSearch'
                        value='1'
                        checked={selectionType === BClientOrEntitySelectorType.Entity}
                        onChange={(e) => setSelectionType(BClientOrEntitySelectorType.Entity)}
                        disabled={disabled}
                    ></input>
                    &nbsp;Borrower Only&nbsp;&nbsp;&nbsp;
                    <input
                        type='radio'
                        name='isBorrowerSearch'
                        value='0'
                        checked={selectionType === BClientOrEntitySelectorType.BClient}
                        onChange={(e) => setSelectionType(BClientOrEntitySelectorType.BClient)}
                        disabled={disabled}
                    ></input>
                    &nbsp;Borrower with B-Client
                    {required && (
                        <label>
                            <span className='req'>*</span>
                        </label>
                    )}
                </div>
            </div>
            <div
                className='row'
                style={styles.formRow}
            >
                <div
                    className='columns small-12 large-12'
                    style={styles.formColumn}
                >
                    {selectionType === BClientOrEntitySelectorType.BClient && (
                        <BrokerAgreementSelect
                            brokerAgreementId={brokerAgreementId}
                            onSelect={(agreement) => onSelect && onSelect(BClientOrEntitySelectorType.BClient, agreement?.id)}
                            showHeader={false}
                            disabled={disabled}
                            required={required}
                        />
                    )}
                    {selectionType === BClientOrEntitySelectorType.Entity && (
                        <EntitySelector
                            entityId={borrowerEntityId}
                            onSelect={(entity) => onSelect && onSelect(BClientOrEntitySelectorType.Entity, entity?.entityId)}
                            canEdit={canEdit}
                            showHeader={false}
                            disabled={disabled}
                            required={required}
                        />
                    )}
                </div>
            </div>
        </>
    );
};
